<template>
    <section>
        <div v-if="loading">
            <Loading />
        </div>
        <div v-else>
            <Nav/>
            <section class="card-container">
                <h1>{{ $t('recipients_page.title') }}</h1>
                <p>{{ $t('recipients_page.intro') }}</p>
                <p>{{ $t('recipients_page.intro_prompt') }}</p>

                <ul class="cards"
                        v-if="list.length > 0"
                        :class="{'grid': list.length > 1, 'small-grid': list.length < 4}">
                    <RecipientCard v-for="item in list" v-bind:key="item.irn" :model="item"></RecipientCard>
                </ul>
                <p v-else class="no-results">{{ $t('labels.no_results') }}</p>
            </section>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { recipient_name } from '@/models/recipient'
import i18n from '@/i18n'

import Loading from '@/components/Loading'
import Nav from '@/components/Nav'
import RecipientCard from '@/components/RecipientCard'
import Themes from "@/components/Themes"

export default {
    components: {
        Loading,
        Nav,
        RecipientCard,
        Themes
    },
    computed: {
        ...mapGetters({
            'list': 'recipients/list',
            'loading': 'recipients/list_loading',
            'filter_province': 'recipients/filter_province',
            'filter_sex': 'recipients/filter_sex',
            'filter_theme': 'themes/list_dict'
        })
    },
    head: {
        title: function() {
            return {
                inner: this.$i18n.t('recipients_page.title'),
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.$i18n.t('recipients_page.intro'), id: 'desc'},

                {property: 'og:title', content: `${this.$i18n.t('recipients_page.title')} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.$i18n.t('recipients_page.intro'), id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.$i18n.t('recipients_page.preview_image')}`, id: 'og-image'}

            ]
        }
    },
    methods: {
        name: (item) => {
            return recipient_name(item)
        },
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                let query = Object.assign({}, this.$route.query);
                this.$store.dispatch('recipients/search', query)
            }
        }
    },
    async mounted() {
        await this.$store.dispatch("recipients/clear_search")
        
        await this.$store.dispatch("recipients/fetch_list", {
            locale: this.$i18n.locale
        })
        await this.$store.dispatch("themes/fetch_list", {
            locale: this.$i18n.locale
        })

        if ("q" in this.$route.query) {
            this.$store.dispatch('recipients/search', this.$route.query)
        }
},
}
</script>

<style scoped>


</style>